import { Link } from "react-router-dom";
import { movieCategories } from "@/mocks/categories";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import usePageMeta from "@/hooks/usePageMeta";

export default function AboutPage() {
  usePageMeta({
    title: "关于我们 - 电影天堂影视内容分享平台",
    description:
      "了解电影天堂的网站定位、内容理念与联系方式。我们专注于最新电影推荐与影视资源内容分享。",
    keywords: "电影天堂,关于我们,影视内容平台,电影推荐",
  });

  const values = [
    { icon: "ri-search-eye-line", title: "快速查找", desc: "清晰的分类与强大的搜索，让你几秒内找到想看的影片。" },
    { icon: "ri-compass-3-line", title: "内容推荐", desc: "基于类型标签的相关推荐，帮你发现更多同类型好片。" },
    { icon: "ri-shield-check-line", title: "纯粹展示", desc: "不提供下载与播放，只做信息的整理与呈现。" },
  ];

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />

      <main className="flex-1">
        <section className="border-b border-background-200/70 bg-background-100/60">
          <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
            <nav className="mb-4 flex flex-wrap items-center gap-1 text-sm text-foreground-400" aria-label="面包屑">
              <Link to="/" className="hover:text-accent-400">首页</Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-foreground-100">关于我们</span>
            </nav>
            <h1 className="text-3xl font-bold text-foreground-50 md:text-4xl">关于电影天堂</h1>
            <p className="mt-4 max-w-3xl text-sm leading-8 text-foreground-300 md:text-base">
              电影天堂是一个专注于最新电影推荐与影视资源内容分享的平台，服务广大电影爱好者与影视资源寻求者。
              我们围绕影视内容的展示与推荐，帮助用户快速查找、浏览和了解最新电影信息。
            </p>
          </div>
        </section>

        <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            {values.map((item) => (
              <div key={item.title} className="rounded-lg bg-background-100 p-6 ring-1 ring-background-200/70">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-100/20 text-accent-500">
                  <i className={`${item.icon} text-2xl`} />
                </span>
                <h2 className="mt-4 text-lg font-medium text-foreground-50">{item.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-foreground-400">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-2">
            <div>
              <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-50 md:text-2xl">
                <span className="h-5 w-1 rounded-full bg-accent-500" />
                网站定位
              </h2>
              <div className="mt-4 space-y-4 text-sm leading-8 text-foreground-300 md:text-base">
                <p>
                  本站内容严格围绕影视内容展示和资源推荐展开，覆盖动作、科幻、剧情、喜剧、爱情、悬疑、动画、恐怖、战争等多种电影类型。
                </p>
                <p>
                  我们希望通过清晰的分类导航、多维度的筛选排序与贴心的相关推荐，让每一位影迷都能高效地找到自己感兴趣的作品。
                </p>
                <p>
                  需要说明的是，电影天堂本身不提供任何视频下载与在线播放服务，页面中所展示的影片信息均为演示用模拟数据，仅用于内容展示与推荐效果的呈现。
                </p>
              </div>
              <div className="mt-6 flex flex-wrap gap-2">
                {movieCategories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="whitespace-nowrap rounded-full bg-background-100 px-3 py-1.5 text-sm text-foreground-300 ring-1 ring-background-200/70 transition hover:text-accent-400"
                  >
                    {cat.name}电影
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-50 md:text-2xl">
                <span className="h-5 w-1 rounded-full bg-accent-500" />
                联系方式与版权
              </h2>
              <div className="mt-4 space-y-3 rounded-lg bg-background-100 p-6 ring-1 ring-background-200/70">
                <p className="flex items-center gap-3 text-sm text-foreground-200">
                  <i className="ri-mail-line text-lg text-accent-500" />
                  contact@dianyingtiantang.demo
                </p>
                <p className="flex items-center gap-3 text-sm text-foreground-200">
                  <i className="ri-phone-line text-lg text-accent-500" />
                  400-000-8888（演示号码）
                </p>
                <p className="flex items-center gap-3 text-sm text-foreground-200">
                  <i className="ri-map-pin-line text-lg text-accent-500" />
                  北京市朝阳区影城路 88 号
                </p>
                <p className="flex items-center gap-3 text-sm text-foreground-200">
                  <i className="ri-time-line text-lg text-accent-500" />
                  每日 09:00 - 23:00
                </p>
              </div>
              <p className="mt-4 text-xs leading-relaxed text-foreground-500">
                本站所有影片名称、海报、简介、资讯及相关数据均为演示内容，不代表真实影视作品。
                站内内容仅供学习与展示，不构成任何实际服务承诺。版权归各内容创作者所有，如有异议请联系我们。
              </p>
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}